import React from 'react'
import PropTypes from 'prop-types'
import { ContainerMain } from './index.style'

const Container = ({ allowOverflow = true, fullWidth = false, children, ...props }) => (
  <ContainerMain allowOverflow={allowOverflow} fullWidth={fullWidth} {...props}>
    {children}
  </ContainerMain>
)

Container.propTypes = {
  allowOverflow: PropTypes.bool,
  fullWidth: PropTypes.bool,
  children: PropTypes.node,
}

export default Container
